<app-vertical-tab-group [useTabColors]="false">

    <app-vertical-tab title="Seeding">
      <app-seeding-report-form></app-seeding-report-form>
    </app-vertical-tab>

    <app-vertical-tab title="Transplanting">
      <app-transplant-report-form></app-transplant-report-form>
    </app-vertical-tab>

    <app-vertical-tab title="Pollination">
      <app-pollination-report-form></app-pollination-report-form>
    </app-vertical-tab>
	
    <app-vertical-tab title="Harvest">
      <app-harvest-report-form></app-harvest-report-form>
    </app-vertical-tab>

    <app-vertical-tab title="Sampling">
      <app-sampling-report-form></app-sampling-report-form>
    </app-vertical-tab>

    <app-vertical-tab title="Capacity">
      <app-capacity-report-form></app-capacity-report-form>
    </app-vertical-tab>

</app-vertical-tab-group>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/reporting-page/reporting-page.component.html